// extracted by mini-css-extract-plugin
export default {"MediatingOrganization":"AccreditationInfo_MediatingOrganization__UxMDW"};